import React from 'react';
import SignInButton from './sign_in_button';
import PropertyLocationMap from './property_location_map';
import PropertyOverviewActions from '../properties/property_overview_actions';
import Ownership from './ownership';
import PropertyValuation from '../../components/search/components/property_valuation';
import PropertyInfoDetails from './property_info_details';
import AiRelatedCompanies from './owners/ai_related_companies';
import PropertyListing from './property_listing';
import EmbeddedMode from '../embedded_mode';

type Props = {
  fromConsole: boolean;
  hasProfile: boolean;
  products: {
    prospecting: boolean;
  };
  property: any;
}

export default function PropertyInfoSection(
  { fromConsole, hasProfile, products, property }: Props
) {
  const showValuation = property.valuation?.estimate;

  return (
    <>
      {!hasProfile && (
        <div className="mb-6">
          <SignInButton />
        </div>
      )}
      <img
        className="w-100 mb-6 d-md-none"
        src={property.streetviewUrl}
        onError={e => e.currentTarget.style.display = 'none'}
      />
      <div className="d-flex flex-column gap-6 mb-6">
        {products.prospecting && (
          <EmbeddedMode>
            <PropertyOverviewActions
              hideNote={fromConsole}
              initialNotes={property.notes}
              insightsPropertyId={property.propertyId}
              tags={property.tags}
            />
          </EmbeddedMode>
        )}
        {fromConsole && property.premiumAccess && (
          <div className="d-flex flex-column gap-3 mb-6">
            <Ownership
              faOwners={property.owners}
              fromConsole
              insightsPropertyId={property.propertyId}
              ownerAddress={property.ownerAddress}
              ownerOccupied={property.ownerOccupied}
            />
            <AiRelatedCompanies fromConsole />
          </div>
        )}
        {showValuation && (
          <div>
            <PropertyValuation listings={property.listings} valuation={property.valuation} />
          </div>
        )}
        {property.listings.forSale && property.listings.salePrice > 0 && (
          <PropertyListing listing={property.listings} />
        )}
        <PropertyInfoDetails hasActiveProduct={products.prospecting} property={property} />
      </div>
      <div className="d-md-none">
        <PropertyLocationMap property={property} />
      </div>
    </>
  );
}
